export default {
  Gradebook: "Bulletin de note",
  Gradebooks: "Bulletins de note",
};
